import React from "react";
import * as M from "@material-ui/core";
import * as Icon from "react-feather";
import { values } from "mobx";
import { useStyles } from "../theme";
import { observer, inject } from "mobx-react";

const SurveyList = ({ store, educationLevel }) => {
  const { $survey, $router, $user, $group } = store;
  const [confirmDelete, toggleConfirmDelete] = React.useState(false);
  const classes = useStyles();
  const { sessionUser } = $user;
  return (
    <div className="md:grid grid-cols-12 gap-8">
      {sessionUser.isVerifiedCreator && (
        <div className="md:col-span-4 lg:col-span-3">
          <M.Card onClick={() => $router.push("/survey/new")} className="h-full cursor-pointer">
            <M.CardContent className="flex justify-between flex-col items-center h-full">
              <div className="mt-4">
                <Icon.Plus className="color-primary" size={90} />
              </div>
              <div className="color-primary mb-4">Nieuwe Enquete</div>
            </M.CardContent>
          </M.Card>
        </div>
      )}
      {values($survey.list)
        .filter(
          survey => (educationLevel && survey.educationLevel === educationLevel) || !educationLevel
        )
        .filter(
          survey =>
            (!$user.sessionUser.isVerifiedCreator && survey.enabled) ||
            $user.sessionUser.isVerifiedCreator
        )
        .filter(
          survey =>
            (survey.cluster &&
              sessionUser.clusters &&
              sessionUser.clusters.find(cluster => cluster === survey.cluster)) ||
            !survey.cluster ||
            !sessionUser.clusters ||
            !(sessionUser.clusters && sessionUser.clusters.length)
        )
        .map(survey => (
          <div className="md:col-span-4 lg:col-span-3" key={survey._key}>
            <M.Card classes={{ root: classes.surveyItem }}>
              <M.CardHeader
                classes={{ root: classes.surveyItemHeader }}
                onClick={() => $router.push("/survey/edit/" + survey._key)}
                title={survey.name}
              />
              <M.CardContent classes={{ root: classes.surveyItemContent }}>
                <div
                  className="flex flex-col items-center justify-between"
                  onClick={() => $router.push("/survey/edit/" + survey._key)}
                >
                  <span>
                    <h2 className="color-primary">
                      {sessionUser.isVerifiedCreator
                        ? survey.respondentCount
                        : $group.selected
                        ? survey.respondentCountForSelectedGroup
                        : survey.respondentCount}
                    </h2>
                  </span>
                  <span>Inzendingen</span>
                  {sessionUser.isVerifiedCreator && (
                    <div>
                      {survey.enabled ? (
                        <b className="color-green">Actief</b>
                      ) : (
                        <b className="color-red">Inactief</b>
                      )}
                    </div>
                  )}
                </div>
              </M.CardContent>
              <M.CardActions classes={{ root: classes.surveyItemActions }}>
                <M.IconButton
                  size="medium"
                  edge="end"
                  onClick={e => {
                    e.stopPropagation();
                    $router.push("/survey/edit/" + survey._key);
                    $survey.setSelected(survey._key);
                  }}
                >
                  {sessionUser.isVerifiedCreator ? (
                    <Icon.Edit2 size={16} color="#444" />
                  ) : (
                    <Icon.List size={16} color="#444" />
                  )}
                </M.IconButton>

                <M.IconButton
                  size="medium"
                  edge="end"
                  onClick={e => {
                    e.stopPropagation();
                    $router.push("/survey/settings/" + survey._key);
                    $survey.setSelected(survey._key);
                  }}
                >
                  <Icon.Settings size={16} color="#444" />
                </M.IconButton>

                <M.IconButton
                  size="medium"
                  edge="end"
                  onClick={e => {
                    e.stopPropagation();
                    $router.push("/survey/share/" + survey._key);
                    $survey.setSelected(survey._key);
                  }}
                >
                  <Icon.Share2 size={16} color="#444" />
                </M.IconButton>

                <M.IconButton
                  size="medium"
                  edge="end"
                  onClick={e => {
                    e.stopPropagation();
                    $router.push("/survey/results/" + survey._key);
                    $survey.setSelected(survey._key);
                  }}
                >
                  <Icon.BarChart2 size={16} color="#444" />
                </M.IconButton>

                {sessionUser.isVerifiedCreator && (
                  <M.IconButton
                    size="medium"
                    onClick={e => {
                      e.stopPropagation();
                      toggleConfirmDelete(survey);
                    }}
                  >
                    <Icon.Trash size={16} color="#444" />
                  </M.IconButton>
                )}
              </M.CardActions>
            </M.Card>
          </div>
        ))}
      <M.Dialog
        open={Boolean(confirmDelete)}
        labelSubmit="Inactief maken"
        onClose={() => toggleConfirmDelete(false)}
      >
        <M.DialogTitle>Let op!</M.DialogTitle>
        <M.DialogContent>
          Deze enquête wordt niet verwijderd maar op inactief geplaatst (onzichtbaar voor gewone
          gebruikers)
        </M.DialogContent>
        <M.DialogActions>
          <M.Button variant="outlined" onClick={() => toggleConfirmDelete(false)}>
            Annuleren
          </M.Button>
          <M.Button
            onClick={() => {
              $survey.list.get(confirmDelete._key).change("enabled", false);
              $survey.list.get(confirmDelete._key).fsSave();
              toggleConfirmDelete(false);
            }}
          >
            OK
          </M.Button>
        </M.DialogActions>
      </M.Dialog>
    </div>
  );
};

export default inject("store")(observer(SurveyList));
